import * as actions from './actionTypes'

//保存新添加设备信息
export const updateDeviceList=(data)=>({
  type:actions.DEVICEMANAGEMENT_UPDATE_DEVICE,
  data,
})
